import DeleteIcon from '@mui/icons-material/Delete';
import { Box } from '@mui/material';
import Grow from '@mui/material/Grow';
import { useState } from 'react';
import { useDispatch } from 'react-redux-latest';
import { AppDispatch } from '../../../../../redux/store/configureStore';
import { RemoveButton } from '../../../../../components/prospects-table/remove-button';
import RemoveReleaseModal from '../../../../../components/remove-release-modal/remove-release-modal';
import { handleErrorNotification, handleSuccessNotification } from '../../../../../redux/actions';
import { ExportContactsButton } from './contactsDownload/export-contacts-button';
import { ProspectDto } from '@zaplify/prospects';
import { ButtonsContainer } from './containers';

const modalContent = {
    title: {
        single: 'Remove Prospect?',
        multiple: 'Remove Prospects?',
    },
    paragraph: {
        single: 'Are you sure you want to remove this prospect? This action cannot be undone.',
        multiple: 'Are you sure you want to remove these prospects? This action cannot be undone.',
    },
    button: {
        single: 'Remove Prospect',
        multiple: 'Remove Prospects',
    },
    toast: {
        single: 'Prospect successfully removed',
        multiple: 'Prospects successfully removed',
    },
};

export const BulkActionButtonGroup = ({
    selected,
    prospectIds,
    removeUserContacts,
    prospectCollectionId,
}: {
    selected: Record<string, ProspectDto>;
    prospectIds: string[];
    removeUserContacts: (ids: string[]) => Promise<void>;
    prospectCollectionId: string;
}) => {
    const dispatch = useDispatch<AppDispatch>();
    const [isRemoveReleaseModalOpen, setIsRemoveReleaseModalOpen] = useState(false);
    const numSelected = Object.keys(selected)?.length || 0;
    const idsOfSelectedProspects = Object.values(selected).map((prospect) => prospect.id);
    const isSelected = Object.keys(selected).length !== 0;

    const showRemoveReleaseModal = () => {
        numSelected && setIsRemoveReleaseModalOpen(true);
    };

    const removeReleaseProspects = async (userContactIds: string[]) => {
        setIsRemoveReleaseModalOpen(false);
        try {
            await removeUserContacts(userContactIds);
            dispatch(handleSuccessNotification('Successfully deleted prospects', 4000));
        } catch (error) {
            console.log('error releaseRemoveProspects', error);
            dispatch(handleErrorNotification('Failed to delete prospects', 5000));
        }
    };

    const handleModalClose = () => {
        setIsRemoveReleaseModalOpen(false);
    };

    const renderText = (paragraph) => {
        if (numSelected > 1) {
            return modalContent[paragraph].multiple;
        } else {
            return modalContent[paragraph].single;
        }
    };

    return (
        <Box className="bulk-action-button-group">
            {isSelected && (
                <Grow in={isSelected} {...(isSelected ? { timeout: 500 } : {})}>
                    <ButtonsContainer>
                        <RemoveButton handleClick={showRemoveReleaseModal} text="Remove" />
                        <ExportContactsButton
                            selected={selected}
                            prospectIds={prospectIds}
                            prospectCollectionId={prospectCollectionId}
                        />
                    </ButtonsContainer>
                </Grow>
            )}
            <RemoveReleaseModal
                isOpen={isRemoveReleaseModalOpen}
                onModalClose={() => handleModalClose()}
                title={renderText('title')}
                paragraph={renderText('paragraph')}
                startIcon={<DeleteIcon />}
                actions={[
                    {
                        text: renderText('button'),
                        method: () => removeReleaseProspects(idsOfSelectedProspects),
                        btnType: 'red',
                    },
                ]}
            />
        </Box>
    );
};
